import { Outlet } from "react-router-dom";
import { WebNavBar } from "../Output/WebNavBar";
import { WebNavFooter } from "../Output/WebNavFooter";

import { DrawerStateProvider } from "../Trays/DrawerStateProvider";
import Drawer, { DrawerSlideEnum } from "../Trays/Drawer";
import Account from "../Trays/Account";

import { ModalStateProvider } from "../Modal/ModalStateProvider";
import ModalContainer from "../Modal/ModalContainer";
import { SwipeProvider } from "../Gestures/SwipeProvider";
import { SnackbarProvider } from "../Snackbars/SnackbarProvider";
import { SeoOptimizer } from "../../Analytics/SeoOptimizer ";
import { GoogleTag } from "../../Analytics/GoogleTag";

export function MobileWebsite() {
	return (
		<SwipeProvider>
			<SeoOptimizer />
			<GoogleTag />
			<DrawerStateProvider>
				<SnackbarProvider>
					<ModalStateProvider>
						{/* MobileTemplate inlined */}
						<div className="min-h-screen flex flex-col bg-primary-background text-primary">
							{/* Top Row - equal width */}
							<div className="h-10"></div>

							{/* Middle Row - main content area */}
							<div className="flex-1">
								<div className="flex-1 flex flex-col pt-4 space-y-4">
									<WebNavBar />
									<div className="flex-1">
										<Outlet />
									</div>
								</div>
							</div>

							{/* Footer at bottom */}
							<WebNavFooter showContour={false} showLinks={true} />

							{/* Bottom Row - equal width */}
							<div className="h-10"></div>
						</div>
						<Drawer position={DrawerSlideEnum.Left}>
							<Account />
						</Drawer>
						<ModalContainer />
					</ModalStateProvider>
				</SnackbarProvider>
			</DrawerStateProvider>
		</SwipeProvider>
	);
}
